/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Backstageuserlimit2Inputs */

const en_entity_backstageuserlimit2 = /** @type {(inputs: Entity_Backstageuserlimit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backstage User Limit`)
};

const de_entity_backstageuserlimit2 = /** @type {(inputs: Entity_Backstageuserlimit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backstage-Benutzerlimit`)
};

/**
* | output |
* | --- |
* | "Backstage User Limit" |
*
* @param {Entity_Backstageuserlimit2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_backstageuserlimit2 = /** @type {((inputs?: Entity_Backstageuserlimit2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Backstageuserlimit2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_backstageuserlimit2(inputs)
	return de_entity_backstageuserlimit2(inputs)
});
export { entity_backstageuserlimit2 as "entity_backstageUserLimit" }